import React from 'react'
import "../CSS/variables.css";
import "../CSS/footer.css";

const Footer = () => {
  return (
    <footer className="footer_container">
        <h1 className="footer_text">Let's build something great together.</h1>
        <button className="footer_btn">Schedule a Call</button>
    </footer>
  )
}

export default Footer